// @core/api/endpoints/subscription/list_product_bundles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductBundlesResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List product bundles
 * Returns available product bundles with optional filtering by status. Public endpoint for bundle catalog browsing.
 * @public This endpoint does not require authentication
 */
export async function ListProductBundles(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductBundlesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bundles`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductBundlesResponse>(requestPath, { ...requestOptions, params });
}
